import RefreshWPMLMetaBox from './RefreshWPMLMetaBox.js';

window.addEventListener("DOMContentLoaded", () => {
	if (wp.data) {
		const refreshWPMLMetaBox = new RefreshWPMLMetaBox(wp.data, ajaxurl);

		refreshWPMLMetaBox.addHooks();
	}
});


// WEBPACK FOOTER //
// ./js/wpml-meta-box/app.js